import SettingGoal from "./SettingGoal";
import SettingUser from "./SettingUser";
import SettingUsers from "./SettingUsers";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "components/ui/tabs";
import SettingSystem from "./SettingSystem";
import { UserRole } from "lib/types";
import { RootState, useAppSelector } from "store";
import SettingLog from "./SettingLog";
import { cn } from "lib/utils";
import { PageContainer, PageHeader } from "components/Layout/PageShell";

const SchoolSetting = () => {
  const me = useAppSelector((state: RootState) => state.user.me);

  return (
    <PageContainer>
      <PageHeader
        title="설정"
        description="계정 정보와 시스템 설정을 관리합니다."
      />
      <Tabs defaultValue="password" className="w-full">
        <TabsList
          className={cn(
            "grid w-full h-auto",
            me.role === UserRole.ADMIN ? "grid-cols-3 sm:grid-cols-5" : "grid-cols-1"
          )}
        >
          <TabsTrigger value="password">암호변경</TabsTrigger>
          {me.role === UserRole.ADMIN && (
            <>
              <TabsTrigger value="goals">목표설정</TabsTrigger>
              {/* <TabsTrigger value="price">단가설정</TabsTrigger> */}
              <TabsTrigger value="user">사용자관리</TabsTrigger>
              <TabsTrigger value="log">로그</TabsTrigger>
              <TabsTrigger value="system">시스템설정</TabsTrigger>
            </>
          )}
        </TabsList>
        <TabsContent value="password" className="pt-8">
          <SettingUser />
        </TabsContent>
        <TabsContent value="goals" className="">
          <SettingGoal />
        </TabsContent>
        {/* <TabsContent value="price" className="pt-8">
          <SettingPrice />
        </TabsContent> */}
        <TabsContent value="user" className="pt-8">
          <SettingUsers />
        </TabsContent>
        <TabsContent value="log" className="pt-8">
          <SettingLog />
        </TabsContent>
        <TabsContent value="system" className="pt-8">
          <SettingSystem />
        </TabsContent>
      </Tabs>
    </PageContainer>
  );
};

export default SchoolSetting;
